"use client"

import { type ReactNode, createContext, use } from "react"
import type { ShopLinks } from "@/app/_actions/shop/_models/shop-links.model"
import type { PaywallModel } from "@/components/Paywall/models/paywall.model"
import type { UserModel } from "@/services/api/profile/models/user.model"
import type { ProductModel } from "@/services/api/shop/models/product.model"

const PaywallContext = createContext<ContextProps | null>(null)

type ContextProps = {
  readonly quarterlyProduct: ProductModel | null
  readonly yearlyProduct: ProductModel | null
  readonly shopLinks: ShopLinks
  readonly redirectUrl: string | null
  readonly articleId: string | null
  readonly user: UserModel
  readonly trial: PaywallModel.Trial | null
}

type PaywallProviderProps = ContextProps & {
  readonly children: ReactNode
}

export function usePaywall(): ContextProps {
  const context = use(PaywallContext)
  if (!context) {
    throw new Error("usePaywall must be used within a PaywallProvider")
  }
  return context
}

export function PaywallProvider({
  children,
  quarterlyProduct,
  yearlyProduct,
  shopLinks,
  redirectUrl,
  articleId,
  user,
  trial,
}: PaywallProviderProps) {
  return (
    <PaywallContext
      value={{
        articleId,
        quarterlyProduct,
        redirectUrl,
        shopLinks,
        trial,
        user,
        yearlyProduct,
      }}
    >
      {children}
    </PaywallContext>
  )
}
